import React, { Component } from 'react'

import {
  Switch,
  Route
} from 'react-router-dom'

import Config from '../Config'
import WindowUtil from '../common/Window'
import NaviBar from './components/NaviBar'
import NaviIconMenu from './components/NaviIconMenu'
import Footer from '../common/component/Footer'
import Login from './pages/public/Login'
import PasswordReset from './pages/public/PasswordReset'
import Dashboard from './pages/secure/Dashboard'

import InformationList from './pages/secure/InformationList'
import InformationDetail from './pages/secure/InformationDetail'

import SharedFileList from './pages/secure/SharedFileList'
import SharedFileDetail from './pages/secure/SharedFileDetail'

import EstimationCreate from './pages/secure/EstimationCreate'
import EstimationCopy from './pages/secure/EstimationCopy'
import EstimationSetupDialog from './pages/secure/EstimationSetupDialog'
import EstimationHome from './pages/secure/EstimationHome'
import EstimationDetail from './pages/secure/EstimationDetail'
import EstimationEdit from './pages/secure/EstimationEdit'

import PersonalSettingHome from './pages/secure/PersonalSettingHome'
import PasswordChange from './pages/secure/PasswordChange'
import EmailChange from './pages/secure/EmailChange'
import NotificationSettingChange from './pages/secure/NotificationSettingChange'

import SurveyAnswer from './pages/secure/SurveyAnswer'
import SurveyAnswerNonLogin from './pages/secure/SurveyAnswerNonLogin'

import AWSAPI from '../common/AWSAPI'

import EstimationStore from './libs/EstimationStore'

// 強制ログアウト設定（本番：120分 開発：30分）
const TOTAL_INACTIVITY_TIMEOUT = Config.sessionTimeout.total
// 警告表示開始時間（本番：10分前 開発：5分前）
const ALERT_DELAY = Config.sessionTimeout.alertDelay
// 警告表示までの時間（本番：110分 開発：25分）
const WARNING_TIMEOUT = TOTAL_INACTIVITY_TIMEOUT - ALERT_DELAY

EstimationStore.init() // EstimationStore を初期化

class CompanyUserApp extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isAlertVisible: false,
      remainingTime: ALERT_DELAY
    }

    this.alertTimeoutId = null
    this.countdownIntervalId = null

    this.handleUserActivity = this.handleUserActivity.bind(this)
    this.startTimers = this.startTimers.bind(this)
    this.resetTimers = this.resetTimers.bind(this)
    this.showAlert = this.showAlert.bind(this)
    this.forceLogout = this.forceLogout.bind(this)
    this.keepSessionAlive = this.keepSessionAlive.bind(this)
    this.formatTime = this.formatTime.bind(this)
  }

  componentDidMount() {
    // ログイン状態を確認しタイマーを開始
    this.startTimers()
  }

  componentWillUnmount() {
    this.clearTimers()
  }

  // タイマーを全てクリアする
  clearTimers() {
    clearTimeout(this.alertTimeoutId)
    clearInterval(this.countdownIntervalId)
  }

  // 警告表示までのタイマーを開始する
  startTimers() {
    this.clearTimers()
    if (AWSAPI.isLoggedIn('companyUser')) {
      // ログイン済みの場合のみタイマーを設定 (110分後に showAlert を実行)
      this.alertTimeoutId = setTimeout(this.showAlert, WARNING_TIMEOUT)
    }
  }

  // タイマーをリセットする (ユーザーアクティビティ発生時)
  resetTimers() {
    // 警告が表示中の場合は非表示にする
    if (this.state.isAlertVisible) {
      this.setState({ isAlertVisible: false })
    }
    this.setState({ remainingTime: ALERT_DELAY })
    this.clearTimers()
    this.startTimers()
  }

  // ユーザーアクティビティ検出時の処理
  handleUserActivity() {
    // ログイン済みの場合のみタイマーをリセット
    if (AWSAPI.isLoggedIn('companyUser')) {
      this.resetTimers()
    }
  }
  
  // 警告アラートを表示する (110分経過後)
  showAlert() {
    this.clearTimers()
    this.setState({ 
      isAlertVisible: true,
      remainingTime: ALERT_DELAY
    })

    const initialMessage = `セキュリティ保持のため、あと ${this.formatTime(ALERT_DELAY)} で自動的にログアウトされます。\n作業中の場合は保存を完了させてください。`
    WindowUtil.setDialogState({
      type: 'alert',
      message: initialMessage,
      onOKButtonClicked: this.keepSessionAlive,
      isOpen: true
    })

    // ログアウトまでのカウントダウンを開始 (1秒ごと)
    this.countdownIntervalId = setInterval(() => {
      this.setState((prevState) => {
        const newRemainingTime = prevState.remainingTime - 1000
        if (newRemainingTime < 1000) {
          clearInterval(this.countdownIntervalId)
          this.forceLogout() // 強制ログアウト処理を呼び出す
          return { remainingTime: 0 }
        }
        const updatedMessage = `セキュリティ保持のため、あと ${this.formatTime(newRemainingTime)} で自動的にログアウトされます。\n作業中の場合は保存を完了させてください。`

        // WindowUtil の状態を更新 (他のプロパティも引き継ぐ)
        const currentDialogState = WindowUtil.getDialogState()
        WindowUtil.setDialogState({
            ...currentDialogState,
            message: updatedMessage
        })

        return { remainingTime: newRemainingTime }
      })
    }, 1000)
  }

  // 「OK」ボタンを押したときの処理
  keepSessionAlive() {
    WindowUtil.closeDialog()
    // アラートを非表示にし、タイマーをリセット
    this.setState({ isAlertVisible: false })
    this.resetTimers()
  }

  handleFinalLogout() {
    AWSAPI.logout('companyUser')
    // 画面リロード（ログイン画面へ遷移）
    window.location.reload()
  }

  // 強制ログアウト処理
  forceLogout() {
    this.clearTimers()
    // 警告ダイアログ（カウントダウン中）を閉じる
    WindowUtil.closeDialog()

    const logoutMessage = '操作がないため、自動的にログアウトしました。'

    WindowUtil.setDialogState({
      type: 'alert',
      message: logoutMessage,
      // OKボタンクリック時に handleFinalLogout を実行する
      onOKButtonClicked: this.handleFinalLogout, 
      isOpen: true
    })
  }

  // ミリ秒を「N分NN秒」形式に整形するヘルパー関数
  formatTime(ms) {
    const totalSeconds = Math.floor(ms / 1000)
    const minutes = Math.floor(totalSeconds / 60)
    const seconds = totalSeconds % 60
    return `${minutes}分${('0' + seconds).slice(-2)}秒`
  }

  renderPublicPages () {
    return (
      <div>
        <Switch>
          <Route exact path='/company_user/password_reset' component={PasswordReset} />
          <Route exact path='/company_user/login' component={Login} />
          <Route exact path='/company_user/survey_answer_nl/:id' component={SurveyAnswerNonLogin} />
          <Route component={Login} />
        </Switch>
      </div>
    )
  }
  renderSecurePages () {
    return (
      <div>
        <NaviBar history={this.props.history} />
        <div id='body-container'>
          <div id='body-content'>
            <NaviIconMenu history={this.props.history} />
            <Switch>
              <Route exact path='/company_user/information' component={InformationList} />
              <Route exact path='/company_user/information/detail/:id' component={InformationDetail} />

              <Route exact path='/company_user/shared_files' component={SharedFileList} />
              <Route exact path='/company_user/shared_files/detail/:id' component={SharedFileDetail} />

              <Route exact path='/company_user/estimation/:estimationType/add' component={EstimationCreate} />
              <Route exact path='/company_user/estimation/:estimationType/copy/:fromId' component={EstimationCopy} />
              <Route exact path='/company_user/estimation/:estimationType/copy/:fromId/:targetEstimationType' component={EstimationSetupDialog} />
              <Route exact path='/company_user/estimation/:estimationType/add/blank' component={EstimationSetupDialog} />
              <Route exact path='/company_user/estimation/:estimationType/detail/:estimationId' component={EstimationDetail} />
              <Route exact path='/company_user/estimation/:estimationType/edit/:estimationId' component={EstimationEdit} />
              <Route exact path='/company_user/estimation/:estimationType/' component={EstimationHome} />

              <Route exact path='/company_user/personal_setting_home' component={PersonalSettingHome} />
              <Route exact path='/company_user/password_change' component={PasswordChange} />
              <Route exact path='/company_user/email_change' component={EmailChange} />
              <Route exact path='/company_user/notification_setting_change' component={NotificationSettingChange} />

              <Route exact path='/company_user/survey_answer' component={SurveyAnswer} />

              <Route component={Dashboard} />
            </Switch>
          </div>
        </div>
        <Footer />
      </div>
    )
  }

  render () {
    let view = null
    if (AWSAPI.isLoggedIn('companyUser')) {
      view = this.renderSecurePages()
    } else {
      view = this.renderPublicPages()
    }
    return view
  }
}

export default CompanyUserApp



// WEBPACK FOOTER //
// ./src/company_user/CompanyUserApp.js